import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Table, Button, Modal, Form, Alert, Card } from "react-bootstrap";
import Navbar from "./Navbar";
import "../styles/InformesPendientes.css";

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const InformesPendientes = () => {
  const [informes, setInformes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDevolverModal, setShowDevolverModal] = useState(false);
  const [selectedInforme, setSelectedInforme] = useState(null);
  const [observacion, setObservacion] = useState("");
  const [showDesestimarModal, setShowDesestimarModal] = useState(false);
  const [observacionDesestimar, setObservacionDesestimar] = useState("");

  useEffect(() => {
    const fetchInformes = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/informes`, {
          headers: getAuthHeaders()
        });
        setInformes(data);
      } catch (error) {
        console.error("❌ Error al obtener informes:", error);
      }
    };
    fetchInformes();
  }, []);

  const aprobarInforme = async (id) => {
    try {
      await axios.put(
        `${API_URL}/api/informes/${id}/confirmar`,
        {
          Estado: "confirmado",
          Observacion: "Aprobado por inspector encargado",
        },
        {
          headers: getAuthHeaders()
        }
      );
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
      console.log("✅ Informe aprobado");
    } catch (error) {
      console.error("❌ Error al aprobar informe:", error);
    }
  };

  const desestimarInforme = async (id, observaciones) => {
    try {
      await axios.put(`${API_URL}/api/informes/${id}/confirmar`, {
        Estado: "desestimado",
        Observacion: observaciones,
      }, {
        headers: getAuthHeaders()
      });
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
      setShowDesestimarModal(false);
      setObservacionDesestimar("");
      setSelectedInforme(null);
      console.log("✅ Informe desestimado");
    } catch (error) {
      console.error("❌ Error al desestimar informe:", error);
    }
  };

  const devolverInforme = async (id, observaciones) => {
    try {
      await axios.put(
        `${API_URL}/api/informes/${id}/devolver`,
        { Observacion: observaciones },
        {
          headers: getAuthHeaders()
        }
      );
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
      setShowDevolverModal(false);
      setObservacion("");
      setSelectedInforme(null);
      console.log("✅ Informe devuelto");
    } catch (error) {
      console.error("❌ Error al devolver informe:", error);
    }
  };

  const abrirModalDesestimar = (informe) => {
    setSelectedInforme(informe);
    setObservacionDesestimar("");
    setShowDesestimarModal(true);
  };

  const verDetalles = (informe) => {
    setSelectedInforme(informe);
    setShowModal(true);
  };

  const abrirModalDevolver = (informe) => {
    setSelectedInforme(informe);
    setObservacion("");
    setShowDevolverModal(true);
  };

  return (
    <div className="informes-container">
      <Navbar />
      <Container className="mt-4">
        <Row>
          <Col>
            <h2 className="mb-4">📋 Informes Pendientes</h2>
            <p className="text-muted mb-4">Administra los informes técnicos generados por los inspectores</p>
            
            {informes.length === 0 ? (
              <Alert variant="info" className="text-center">
                <Alert.Heading>📄 No hay informes pendientes</Alert.Heading>
                <p className="mb-0">No se encontraron informes en el sistema para revisar.</p>
              </Alert>
            ) : (
              <Card>
                <Card.Body className="p-0">
                  <Table striped bordered hover responsive className="mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th style={{width: '120px'}}>N° Informe</th>
                        <th style={{width: 'auto'}}>Inspector</th>
                        <th style={{width: 'auto'}}>Motivo</th>
                        <th style={{width: '120px'}}>Fecha</th>
                        <th style={{width: '240px'}}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {informes.map(informe => (
                        <tr key={informe.id}>
                          <td>
                            <code className="bg-light px-2 py-1 rounded">{informe.NroInforme}</code>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="bg-secondary rounded-circle d-flex align-items-center justify-content-center me-2" 
                                   style={{width: '32px', height: '32px', fontSize: '12px', color: 'white'}}>
                                {informe.NombreInformante?.charAt(0)?.toUpperCase() || 'U'}
                              </div>
                              <small>{informe.NombreInformante || 'Usuario desconocido'}</small>
                            </div>
                          </td>
                          <td>
                            <div className="text-truncate" style={{maxWidth: '200px'}} title={informe.Motivo}>
                              {informe.Motivo}
                            </div>
                          </td>
                          <td>
                            <small className="badge bg-secondary">{informe.FechaRealizado?.split('T')[0]}</small>
                          </td>
                          <td>
                            <div className="d-flex gap-1 justify-content-center">
                              <Button 
                                variant="outline-success" 
                                size="sm"
                                onClick={() => aprobarInforme(informe.id)}
                                title="Aprobar informe"
                                className="rounded-circle px-2 py-1"
                                style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                              >
                                ✓
                              </Button>
                              <Button 
                                variant="outline-danger" 
                                size="sm"
                                onClick={() => abrirModalDesestimar(informe)}
                                title="Desestimar informe"
                                className="rounded-circle px-2 py-1"
                                style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                              >
                                ✕
                              </Button>
                              <Button 
                                variant="outline-primary" 
                                size="sm"
                                onClick={() => verDetalles(informe)}
                                title="Ver detalles"
                                className="rounded-circle px-2 py-1"
                                style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                              >
                                👁
                              </Button>
                              <Button 
                                variant="outline-secondary" 
                                size="sm"
                                onClick={() => abrirModalDevolver(informe)}
                                title="Devolver para edición"
                                className="rounded-circle px-2 py-1"
                                style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                              >
                                ↩
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      </Container>

      {/* Modal de detalles */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            📋 Detalles del Informe #{selectedInforme?.NroInforme}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedInforme && (
            <div>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>🔍 Inspector:</strong>
                  <div className="mt-1">{selectedInforme.NombreInformante || 'Desconocido'}</div>
                </Col>
                <Col md={6}>
                  <strong>👤 Empleado:</strong>
                  <div className="mt-1">
                    {selectedInforme.NombreEmp} (Legajo {selectedInforme.LegajoEmp})
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>📅 Fecha:</strong>
                  <div className="mt-1">{selectedInforme.FechaRealizado?.split("T")[0]}</div>
                </Col>
                <Col md={6}>
                  <strong>🕐 Hora:</strong>
                  <div className="mt-1">{selectedInforme.Hora}</div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <strong>📝 Motivo:</strong>
                  <div className="mt-2 p-3 bg-light border rounded">
                    {selectedInforme.Motivo}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <strong>📋 Detalle:</strong>
                  <div className="mt-2 p-3 bg-light border rounded">
                    {selectedInforme.MotivoDetalle}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <strong>⚡ Estado:</strong>
                  <div className="mt-1">
                    <span className="badge bg-warning text-dark">{selectedInforme.Estado}</span>
                  </div>
                </Col>
              </Row>
              
              {selectedInforme.Observacion && (
                <Row className="mb-3">
                  <Col>
                    <strong>💬 Observación:</strong>
                    <div className="mt-2 p-3 bg-info bg-opacity-25 border border-info rounded">
                      {selectedInforme.Observacion}
                    </div>
                  </Col>
                </Row>
              )}
              {selectedInforme.SancionPropuesta && (
                <Row className="mb-3">
                  <Col>
                    <strong>⚖️ Sanción propuesta:</strong>
                    <div className="mt-2 p-3 bg-warning bg-opacity-25 border border-warning rounded">
                      {selectedInforme.SancionPropuesta}
                    </div>
                  </Col>
                </Row>
              )}
              {selectedInforme.SancionAplicada && (
                <Row className="mb-3">
                  <Col>
                    <strong>✅ Sanción aplicada:</strong>
                    <div className="mt-2 p-3 bg-danger bg-opacity-25 border border-danger rounded">
                      {selectedInforme.SancionAplicada}
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de devolución */}
      <Modal show={showDevolverModal} onHide={() => setShowDevolverModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>↩ Devolver informe #{selectedInforme?.NroInforme}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>💬 Motivo de devolución:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="Escriba la observación para el inspector..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDevolverModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={() => devolverInforme(selectedInforme.id, observacion)}
            disabled={!observacion.trim()}
          >
            Devolver
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de desestimar */}
      <Modal show={showDesestimarModal} onHide={() => setShowDesestimarModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>❌ Desestimar informe #{selectedInforme?.NroInforme}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>💬 Motivo de desestimación:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={observacionDesestimar}
              onChange={(e) => setObservacionDesestimar(e.target.value)}
              placeholder="Escriba la observación para el inspector..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDesestimarModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => desestimarInforme(selectedInforme.id, observacionDesestimar)}
            disabled={!observacionDesestimar.trim()}
          >
            Desestimar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InformesPendientes;